import { Link, useLocation } from '@tanstack/react-router';
import { ChartColumnIncreasing } from 'lucide-react';

const TO = '/performance-beta';

// Bottom-of-sidebar entry for the consolidated Performance page, in the same
// stacked icon-over-label shape as the Account and Admin triggers beside it.
// The pill over the icon is what says it is a beta; the label stays
// "Performance" so it reads as the same page as the main-nav one.
export function PerformanceBetaLink() {
  const { pathname } = useLocation();
  const isActive = pathname === TO || pathname.startsWith(`${TO}/`);

  return (
    <Link
      to={TO}
      aria-current={isActive ? 'page' : undefined}
      className={`flex w-full flex-col items-center gap-1 rounded-lg px-1 py-2 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[#290BD9] focus-visible:ring-inset ${
        isActive ? 'text-[#290BD9] bg-[#290BD9]/10 cursor-default' : 'text-gray-900 hover:bg-gray-50 cursor-pointer'
      }`}
    >
      <span className="relative">
        <ChartColumnIncreasing className="h-5 w-5" strokeWidth={1.5} />
        <span className="absolute -top-2 -right-4 rounded-full bg-[#290BD9] px-1 py-px text-[8px] font-bold uppercase leading-none tracking-wide text-white">
          Beta
        </span>
      </span>
      <span className="max-w-full truncate text-[10px] font-medium leading-none">Performance</span>
    </Link>
  );
}
